import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse } from '../models';
import { IInvoiceDetail, IInvoiceRes, IInvoiceStatus, ISelectableVendor } from '../models/invoices';

export const getInvoices = async (filters?: {
  search?: string;
  vendorSageId?: string | number;
  vendorTypeId?: string;
  subcontractorTypeId?: string;
  status?: string;
  invoiceNumber?: string;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
  jobSageId?: number;
}): Promise<IInvoiceRes> => {
  try {
    const { data } = await axios.get(`/api/invoices`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getInvoices failed');
    return Promise.reject(error);
  }
};

export const getInvoiceStatuses = async (): Promise<IInvoiceStatus[]> => {
  try {
    const { data } = await axios.get(`/api/invoices/statuses`);
    return data;
  } catch (error) {
    logError(error, 'getInvoiceStatuses failed');
    return Promise.reject(error);
  }
};

export const getInvoiceDetails = async (invoiceNumber: string): Promise<IInvoiceDetail | any> => {
  try {
    const { data } = await axios.get(`/api/invoices/${invoiceNumber}`);
    return data;
  } catch (error) {
    logError(error, 'getInvoiceDetails failed');
    return error.response.data;
  }
};

export const getInvoiceVendors = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
  name?: string;
}): Promise<IResponse<ISelectableVendor[]>> => {
  try {
    const { data } = await axios.get(`/api/invoices/vendors`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getInvoiceVendors failed');
    return Promise.reject(error);
  }
};
